/**
 * Converts an object to array of name-answer pairs
 * It's used to send answers to the questions API in the correct format
 */
export function mapToArray(
  object: Record<string, unknown>,
): Record<string, unknown>[] {
  return Object.entries(object).map(([name, answer]) => ({ name, answer }));
}
